<template lang="pug">
.panel-page
  .panel.mx-auto
    FormErrorAlert(:message="message" v-show="message !== ''" @dismiss="message = ''")
    h1 Verify Account
    p.body-1 Please confirm your verification code to verify your account.
    form(
      @submit.prevent="verify()"
      autocomplete="off"
    )
      .form-group
        label(for="verification-code")
        input#verification-code.form-control(v-model="code")
      button.btn.btn-primary(type="submit") Verify
</template>

<script>
import FormErrorAlert from '@/components/FormErrorAlert'
import axios from '@/lib/axios'
import { globalSuccess, globalError } from '@/lib/utils'

export default {
  name: 'Verify',
  data: function() {
    return {
      code: '',
      username: '',
      message: '',
    }
  },
  methods: {
    verify() {
      axios()
        .post('/api/verify', {
          username: this.username,
          verify_code: this.code,
        })
        .then(() =>
          globalSuccess(
            null,
            'The account is verified, but will not be able to log in until an administrator has approved it.',
          ),
        )
        .then(() => this.$router.push({ name: 'login' }))
        .catch(err => globalError(err))
    },
  },
  components: {
    FormErrorAlert,
  },
  mounted() {
    this.code = this.$route.query.code
    this.username = this.$route.query.username
  },
}
</script>

<style lang="scss" scoped>
</style>
